import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const EmptyLayout: FC = () => <Outlet />;
